// src/pages/CareerAdvice.jsx
import React from 'react';

const CareerAdvice = () => {
  return (
    <div className="container py-5">
      <h2 className="mb-4 text-primary">Career Advice</h2>
      <p>
        🚀 Welcome to the Career Advice hub! Whether you're a student or a professional,
        here's where we help you take the next step in your journey.
      </p>

      <h4 className="mt-4">🔥 Hot Tips:</h4>
      <ul>
        <li>🎯 Identify your strengths — play to them.</li>
        <li>🧠 Never stop learning — stay relevant with trends.</li>
        <li>🤝 Network, not just online — in real life too.</li>
        <li>📄 Resume = your marketing pitch. Make it strong.</li>
        <li>🛠️ Build projects. Real ones. Show what you can do.</li>
        <li>🎤 Prepare for interviews like you're on Shark Tank.</li>
      </ul>

      <p className="mt-4">
        Want personalized advice? Stay tuned. LadderUp is building smart tools to guide your career step-by-step.
      </p>
    </div>
  );
};

export default CareerAdvice;
